import React from 'react';
import ReactDialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import { makeStyles } from '../../theme';
import Button, { ImportantButton } from '../button';
import { isString } from '../../../util';

/**
 * Use `theme settings` as much as possible instead of hard-coded values.
 * More theme settings on: https://material-ui.com/customization/theming/
 */
const styles = makeStyles(
    ({ spacing }) => ({
        paperRoot: {
            padding: spacing(2)
        }
    })
)

const Dialog = React.memo(
    ({ open, title, body, confirmBtnCls, onConfirm, confirmBtnTxt, cancelBtnCls, onCancel, cancelBtnTxt, disableConfirm = false, ...props }) => {
        const classes = styles();

        return open && (
            <ReactDialog {...props} open={open} PaperProps={{ className: classes.paperRoot }}>
                {title && <DialogTitle>{title}</DialogTitle>}
                {body && 
					isString(body) ? (
						<DialogContent>
							<DialogContentText>{body}</DialogContentText>
						</DialogContent>
					) : (
						<DialogContent>{body}</DialogContent>
					)
				}
                <DialogActions>
                    {onCancel && (
                        <Button onClick={onCancel} label={cancelBtnTxt} className={cancelBtnCls} />
                    )}
                    {onConfirm && (
                        <ImportantButton onClick={onConfirm} label={confirmBtnTxt} className={confirmBtnCls} disabled={disableConfirm} />
                    )}
                </DialogActions>
            </ReactDialog>
        );
    }
);

export default Dialog;

export function useDialog() {
    const [open, setShowDialog] = React.useState(false);

    const openDialog = () => {
        setShowDialog(true);
    }

    const closeDialog = () => {
        setShowDialog(false);
    }

    return [ open, openDialog, closeDialog ];
}